import { Fragment } from "react";

import IconTable from "componentsv2/table/IconTable";
import { triggerMethod } from "tools/helpers";
import factoryCell from "componentsv2/table/factoryCell";
import { getFromId } from "storev2/common";

/**
 * Define cell for row FIXME
 * @param {Boolean} readOnly - optional selectable
 * @param {Boolean} selectable - optional default true
 * @param {Function} children - callback function on click cell
 * @param {ChildNode} Component - Component to render as child
 * @param {String} textAling - optional align text for cell [left, right, center] default center
 * @param {String} color - define color for cell
 * @param {Array} style - define style for cell
 */

function TableRowContent({
  layout,
  record,
  fieldName,
  onActionButton,
  onClickCell,
  cellButtonEnd,
  cellButtonStart,
  isChecked,
  triggerUpdate,
  storeId,
  updateRow,
  parentRec,
}) {
  function handleCheck() {}
  const listView = layout.list
    ?.map((val) => {
      return { ...layout.fields[val.name], ...val };
    })
    .filter((field) => !field.invisible);

  function onChange(field, value, rec) {
    const _record = { ...record.value, ...rec };
    _record[field.name] = value;

    if (field.withChange) {
      field.withChange(field.name, _record, value);
      record.value = _record;
    }
    if (field.editable && field.type !== "numeric") {
      record.value = _record;
    }

    if (triggerUpdate) {
      // Now we pass record signal
      triggerUpdate(record, field, value);
    }
    console.log("updateRow _record ", storeId, _record);
    updateRow(storeId, _record);
  }

  // function onChange(field, value, rec) {
  //   console.log(rec, "rec");
  //   console.log(record.value, "record.value");

  //   let _record = { ...rec };

  //   _record[field.name] = value;
  //   record.value = _record;

  //   if (field.withChange) {
  //     field.withChange(field.name, _record, value);
  //   }

  //   if (triggerUpdate) {
  //     triggerUpdate();
  //   }
  // }

  async function triggerAction(record_, method) {
    if (typeof method !== "string") {
      await method(record_);
      return;
    }
    // Here update record in API database
    await triggerMethod(layout.model, method, record_, false);
    // Here get record updated from database
    const recUpdated = await getFromId(record_.id, layout.model, layout);
    // Here update UI triggering re-rendering for a single row
    record.value = recUpdated;
    console.log(" triggerAction ? ", record_);
    if (triggerUpdate) {
      // This is for update external values / components outside of the table
      triggerUpdate();
    }
  }

  function onClickEdit(e, name, record) {
    e.preventDefault();
    e.stopPropagation();
    onActionButton(e, name, record);
  }

  function actionButtonStart(rec, value) {
    return (
      <td key={value} className="text-center w-8 p-1 h-full">
        <button
          type="button"
          className="flex bg-blue-200 h-full w-4 active:bg-blue-300 active:scale-90 cursor-pointer rounded-sm min-h-5"
          name={value}
          record={rec}
          onClick={(e) => onClickEdit(e, value, rec)}
        />
      </td>
    );
  }

  function actionButtonEnd(rec, value) {
    return (
      <td key={value} className="text-center w-11">
        <IconTable name={value} record={rec} onClickButton={onActionButton} />
      </td>
    );
  }

  return (
    <Fragment>
      {layout.selectable === "multi" && (
        <td key={record.value.id} className="text-center w-10">
          <input
            key={record.value.id}
            type="checkbox"
            name={"selectable"}
            onChange={handleCheck}
            checked={isChecked}
            className="h-4 w-4 rounded-lg accent-amber-400"
          />
        </td>
      )}
      {cellButtonStart.map((value, index) =>
        actionButtonStart(record.value, value, index),
      )}
      {listView &&
        listView.map((field, key) => {
          return factoryCell({
            key,
            field,
            record: record.value,
            layout,
            model: layout.model,
            parentRec: null,
            fieldName,
            triggerAction,
            onClickCell,
            onChange: (f, v, rec) => onChange(f, v, rec),
            storeId,
          });
        })}
      {cellButtonEnd.map((value, index) =>
        actionButtonEnd(record.value, value, index),
      )}
    </Fragment>
  );
}

export default TableRowContent;
